// The centered page frame for the whole desktop app. Every page renders inside it: on a big monitor the content sits in the middle (about 1680px wide) with even gutters instead of
// pinned to the left; on a smaller screen it simply fills the width, so nothing is squeezed. A page that sets its own narrower max width (a form, a report) is centered inside it by
// the .page-container rule in App.css. Phone layouts do not use it. Sticky pieces keep working because the frame does not scroll: the shell's content area still does.
import React from 'react';

export const PAGE_MAX_WIDTH = 1680;

export default function PageContainer({ children, maxWidth = PAGE_MAX_WIDTH }) {
  return (
    <div className="page-container" data-testid="page-container" style={{ width: '100%', maxWidth, margin: '0 auto', height: '100%', boxSizing: 'border-box' }}>
      {children}
    </div>
  );
}
